module.exports = __webpack_public_path__ + "static/img/04.84cc029c.jpg";